import { computed, type MaybeRef, unref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { isNil } from 'lodash-es';
import type { AxiosResponse } from 'axios';
import type { hotOffers } from 'shared';

import { api } from '@/shared/api';
import { mapOffersResults } from '@/shared/lib';

export function getHotRoutesQueryOptions({
  origCityCode,
  destCityCode,
}: {
  origCityCode: MaybeRef<string>;
  destCityCode: MaybeRef<string | null>;
}) {
  return {
    queryKey: ['hot-offers', 'routes', origCityCode, destCityCode],
    queryFn: () => {
      return api.hotOffers.route({
        origCity: unref(origCityCode),
        destCity: unref(destCityCode),
      });
    },
    enabled: computed(() => !isNil(unref(destCityCode))),
    staleTime: 3 * 60 * 1000,
  };
}

export function useHotRoutesQuery({
  origCityCode,
  destCityCode,
}: {
  origCityCode: MaybeRef<string>;
  destCityCode: MaybeRef<string | null>;
}) {
  // TODO: Add abort signal when closing bottom sheet
  const hotRoutesQuery = useQuery<AxiosResponse<hotOffers.HotOffersResponse>>(
    getHotRoutesQueryOptions({
      origCityCode,
      destCityCode,
    }),
  );

  const hotRoutes = computed(
    () => hotRoutesQuery.data.value?.data.results.map(mapOffersResults) ?? [],
  );

  const isRoutesLoading = computed(() => hotRoutesQuery.isLoading.value);

  return {
    hotRoutes,
    isRoutesLoading,
  };
}
